// extracted by mini-css-extract-plugin
export default {"productDescription":"n_-z","featuredDescription":"o_-z","description":"p_-z","more":"q_-z","descriptionSku":"r_-z"};